/* eslint-disable */

// import FlashMessage from 'react-native-flash-message';
import React, {
  ReactElement,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
// import ImageResizer from 'react-native-image-resizer';
import {
  Appearance,
  Dimensions,
  Image,
  LogBox,
  PermissionsAndroid,
  Platform,
  ScrollView,
  TextStyle,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from 'react-native';
import {createStackNavigator} from '@react-navigation/stack';
// import {showMessage, hideMessage} from 'react-native-flash-message';
// import database from '@react-native-firebase/database'; // If you have added Firebase database else omit this line
// import auth from '@react-native-firebase/auth'; // If you have added Firebase authentication else omit this line
import {
  ApplicationProvider,
  Button,
  Divider,
  Icon,
  IconRegistry,
  Layout,
  List,
  Modal,
  Spinner,
  Text,
  TextProps,
  Toggle,
} from '@ui-kitten/components';
import {EvaIconsPack} from '@ui-kitten/eva-icons';
import * as eva from '@eva-design/eva';
import * as Animatable from 'react-native-animatable';
import AsyncStorage from '@react-native-async-storage/async-storage';
//import logo from './logo.png';
//import loginImage from './images/login.jpg';
import {EvaSize, EvaStatus, RenderProp} from '@ui-kitten/components/devsupport';

import {PhoneNumberUtil} from 'google-libphonenumber';
import LinearGradient from 'react-native-web-linear-gradient';
//import DatePicker from "react-native-date-picker";
import {
  SafeAreaProvider,
  useSafeAreaFrame,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import {ButtonProps} from '@ui-kitten/components/ui/button/button.component';
import Speedometer from './Speedometer/Speedometer';
import Arc from './Speedometer/Arc';
import Progress from './Speedometer/Progress';
//import DatePicker from "react-native-date-picker";
//import {Gesture} from 'react-native-gesture-handler';

function getParameterByName(name) {
  try {
    let options = window.location.href;
    name += '=';
    let firstIndex = options.indexOf(name);
    if (firstIndex !== -1) {
      options = options.substring(firstIndex + name.length);
      let results = options.split('&').filter(s => s.trim() !== '');
      //console.log(location.search + '\n' + options + '\n' + results);
      return results.length ? decodeURIComponent(results[0]) : '';
    }
  } catch (e) {
    console.log(e);
  }
}

let userID = getParameterByName('userID');
let password = getParameterByName('password');

const phoneUtil = PhoneNumberUtil.getInstance();
const isIOS = Platform.OS === 'ios';
const isAndroid = Platform.OS === 'android';
const isWeb = Platform.OS === 'web';
LogBox.ignoreLogs(['']);

const ignoreWarns = [
  'Text: unsupported configuration',
  'componentWillMount',
  'componentWillReceiveProps',
  'The action \'NAVIGATE\' with payload {"name":"Opening Screen"} was not handled by any navigator',
  'Cannot update a component',
  'Each child in a list should have a unique "key" prop',
  'Material Top Tab Navigator',
  'The prop `selection.start` is marked as required',
];

const warn = console.warn;
const error = console.error;
console.warn = (...arg) => {
  for (const warning of ignoreWarns) {
    for (let ar of arg) {
      if (getString(ar).toLowerCase().includes(warning?.toLowerCase())) {
        return;
      }
    }
  }
  warn(...arg);
};
console.error = (...arg) => {
  for (const warning of ignoreWarns) {
    for (let ar of arg) {
      if (getString(ar).toLowerCase().includes(warning?.toLowerCase())) {
        return;
      }
    }
  }
  error(...arg);
};

function getString(obj, separator = '\t', strict) {
  if (!checkValue(obj)) return obj;
  return typeof obj === 'string'
    ? obj
    : obj && obj.message && !strict
    ? obj.message
    : JSON.stringify(obj, undefined, separator);
}

const useWindow = () => {
  const window = useSafeAreaFrame();
  const insets = useSafeAreaInsets();
  const {width, height} = Dimensions.get('window');
  return {
    ...window,
    ...insets,
    height: window.height - insets.top - insets.bottom,
    width: window.width - insets.left - insets.right,
    windowWidth: width,
    windowHeight: height,
  };
};

let themeName = Appearance.getColorScheme() ?? 'light';

let primaryColor,
  secondaryColor,
  thirdColor,
  fourthColor,
  fifthColor,
  backgroundColor1,
  backgroundColor2,
  backgroundColor3,
  backgroundColor4,
  backgroundColor5,
  shadow,
  antiShadow,
  styles;

//const thirdColor = 'lightskyblue';
//const thirdColorCode = '#87cefa';
let semiTransparent;
const transparent = '#0000';
const black = '#000';
const white = '#fff';

const appName = 'RM Solaar';
const project_id = 'rmsolaar-web';
//let sample_data = require('./data.json');
//if (sample_data) sample_data = sample_data[appName];

const themeChangeListeners = [];
const ThemeChangeButton = props => {
  const primaryToggleState = useToggleState(themeName === 'dark', isChecked => {
    const theme = isChecked ? 'dark' : 'light';
    //log(Appearance.getColorScheme());
    if (Appearance.getColorScheme() === theme) removeUserSession('theme');
    else storeUserSession('theme', theme);
    themeSelected(theme);
  });
  const themeSelected = theme => {
    if (theme && theme !== themeName) {
      themeName = theme;
      generateColorsAndStyles().then(() => {
        themeChangeListeners.forEach(lis => lis(themeName));
      });
    }
  };
  useEffect(() => {
    const doIt = async () => {
      const theme = await retrieveUserSession('theme');
      themeSelected(theme);
    };
    doIt();
  }, []);

  const {hidden, themNameFormatter} = props;

  if (hidden) return null;

  return (
    <Toggle {...primaryToggleState} {...props} checked={themeName === 'dark'}>
      {p => (
        <Text
          {...p}
          {...props}
          style={{...p.style, ...props.style, fontWeight: 'bold'}}>
          {themNameFormatter
            ? themNameFormatter(themeName)
            : themeName.toUpperCase()}
        </Text>
      )}
    </Toggle>
  );
};

function deleteUndefinedAndNull(obj) {
  for (let k in obj) {
    if (!checkValue(obj[k])) delete obj[k];
  }
  return obj;
}

const SpeedBackground = props => {
  let {
    value,
    max,
    min,
    children,
    style,
    colorChange,
    mediumColorRatio,
    lowColorRation,
    reverseBackground,
  } = props;
  if (!isNumeric(value)) value = min;
  let backgroundColor = style?.backgroundColor;
  if (!backgroundColor) backgroundColor = backgroundColor3;
  let foregroundColor = thirdColor;
  if (colorChange) {
    let {color, status} = getStatusColor(
      value,
      max,
      min,
      mediumColorRatio,
      lowColorRation,
      reverseBackground,
    );
    foregroundColor = color;
  }
  const {flexDirection} = style ? style : {};
  let widthOrHeight = (value / max) * 100;
  if (!isNumeric(widthOrHeight)) widthOrHeight = 0;
  widthOrHeight += '%';
  const isRowView = flexDirection === 'row';

  return (
    <View style={{...style, overflow: 'hidden', backgroundColor}}>
      {!GlobalState.v.turnOffGraphics && (
        <Animatable.View
          transition={isRowView ? 'height' : 'width'}
          duration={200}
          style={{
            ...style,
            borderTopLeftRadius: undefined,
            borderTopRightRadius: undefined,
            borderBottomRightRadius: undefined,
            borderBottomLeftRadius: undefined,
            position: 'absolute',
            alignSelf: isRowView ? 'flex-end' : 'flex-start',
            height: isRowView ? widthOrHeight : '100%',
            width: !isRowView ? widthOrHeight : '100%',
            backgroundColor: foregroundColor,
          }}
        />
      )}
      {children}
    </View>
  );
};

const reduceArray = (array, maxLength) => {
  if (array?.length >= maxLength) {
    const removedElements = [];
    const length = maxLength / 5;
    for (let i = 0; i < length; i++) {
      const element = array[i];
      removedElements.push(i);
    }
    removedElements.forEach(ele => {
      array.remove(ele);
    });
    return removedElements;
  }
};

function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

function timeBetweenTimes(startHour, startMinute, endHour, endMinute) {
  const marketOpen = startHour * 60 + startMinute; // minutes
  const marketClosed = endHour * 60 + endMinute; // minutes
  var now = new Date();
  var currentTime = now.getHours() * 60 + now.getMinutes(); // Minutes since Midnight
  // log('hello ' + currentTime + ' ' + marketOpen + ' ' + marketClosed);

  return currentTime >= marketOpen && currentTime < marketClosed;
}

function dateBetweenTwoDates(startDate, endDate, targetDate) {
  startDate = new Date(startDate);
  startDate.setHours(0, 0, 0, 0);
  endDate = new Date(endDate);
  endDate.setHours(23, 59, 0, 0);
  targetDate = new Date(targetDate);
  const s = startDate.getTime();
  const e = endDate.getTime();
  const t = targetDate.getTime();
  return t >= s && t < e;
}

const readContentFromFile = (file, dataType, callBack) => {
  const isBase64 = dataType === 'base64';
  //dataType is either 'text' or 'base64'
  if (file) {
    const reader = new FileReader();

    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      // Do whatever you want with the file contents
      let content = reader.result;
      const text = isBase64 ? reader.result?.split(',')[1] : content;

      callBack && callBack(file.name, file.size, text, file.type);
      /*state.v.imageToUpload = base64String && base64String.split(',')[1];
                  state.v.image = base64String;
                  setState({...state});*/
    };
    //state.v.image=file;
    if (isBase64) {
      reader.readAsDataURL(file);
    } else {
      reader.readAsText(file);
    }
  }
};

function getElevationProps(pick) {
  return {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: backgroundColor1,
    ...(pick ? {zIndex: 99, elevation: 99} : {zIndex: 1, elevation: 1}),
  };
}

function trimString(str, length) {
  if (typeof str === 'string') {
    return str?.length <= length ? str : str.substring(0, length - 4) + ' ...';
  }
  return str;
}
/**
 *
 * @param width {string | number}
 * @param elements {function | Array<{type:'input' | 'date' | 'select' | 'multiSelect', path: string, title: string, icon: string | Object | function | ReactElement, selectObject: Object, otherProps:Object}>}
 * @param extraElements {function | ReactElement}
 * @param dialogState {Object}
 * @param callBack {function}
 * @param initialValue {Object}
 * @param isValueSatisfied {function}
 * @param showInFullScreen {boolean}
 * @param status {EvaStatus}
 * @param doNotScroll {boolean}
 * @param doNotCenterAlign {boolean}
 */
const askForName = (
  width,
  elements,
  extraElements,
  dialogState,
  callBack,
  initialValue,
  isValueSatisfied,
  showInFullScreen,
  status,
  doNotScroll,
  doNotCenterAlign = true,
) => {
  const v = initialValue ? initialValue : {};
  let elementWidth = width ?? (isWeb ? 380 : '100%');
  const onHide = sendNull => {
    if (sendNull) callBack && callBack(null);
    hideMessage();
  };

  const onConfirm = () => {
    let b = !isValueSatisfied || isValueSatisfied(v);
    if (b) {
      onHide();
      callBack && callBack(v);
    }
  };
  const onUpdate = () => {
    notifyMessage(
      getView(),
      undefined,
      false,
      0,
      false,
      status,
      showInFullScreen,
      true,
    );
  };
  const getView = () => {
    let e;
    if (typeof elements === 'function') e = elements(v);
    else e = elements;
    if (!Array.isArray(e))
      e = [
        {
          type: 'input',
          path: 'name',
          icon: 'person',
          //otherProps: {style: {width: '100%'}, childStyle: {width: '100%'}},
        },
      ];
    return (
      <Layout
        style={{
          ...(showInFullScreen ? {width: '100%', height: '100%'} : undefined),
          ...(doNotCenterAlign
            ? undefined
            : {justifyContent: 'center', alignItems: 'center'}),
        }}>
        {getFunctionData(() => {
          const Component = doNotScroll ? View : ScrollView2;
          return (
            <Component
              doNotScrollToBottom={true}
              style={{
                flex: showInFullScreen ? 1 : undefined,
              }}>
              {e.map(element =>
                getElementField(element, v, elementWidth, null, onUpdate),
              )}
              {typeof extraElements === 'function'
                ? extraElements(v, onUpdate)
                : extraElements}
            </Component>
          );
        })}

        <View style={styles.rowViewWithoutShadow}>
          <Button
            appearance={'outline'}
            style={{margin: 7, flex: 1}}
            onPress={onConfirm}
            accessoryRight={
              <AnimatedIcon animation="shake" name="arrow-circle-right" />
            }>
            OK
          </Button>
          <Button
            appearance={'outline'}
            status={'basic'}
            style={{margin: 7, flex: 1}}
            onPress={() => onHide(true)}
            accessoryRight={
              <AnimatedIcon animation="shake" name="close-circle" />
            }
            PULSE>
            Close
          </Button>
        </View>
      </Layout>
    );
  };
  if (dialogState) {
    Object.assign(dialogState, {onHide, value: v, onConfirm, onUpdate});
  }
  onUpdate();
};

//log('hello');

const ButtonGroup2 = (props: {
  buttons: string[],
  style?: ViewStyle,
  selectedIndex: number,
  onPress: (index: number) => any,
  selectedStatus?: EvaStatus,
  status?: EvaStatus,
  selectedIndexes?: number[],
  accessoryLeft?: Array<(props => ReactElement) | ReactElement>,
  accessoryRight?: Array<(props => ReactElement) | ReactElement>,
}) => {
  let {
    buttons,
    style,
    selectedIndex,
    onPress,
    selectedStatus,
    status,
    selectedIndexes,
    accessoryLeft,
    accessoryRight,
  } = props;
  if (!status) {
    status = 'basic';
  }
  if (!selectedStatus) {
    selectedStatus = 'info';
  }

  const borderRadius = 20;

  const st = {backgroundColor: backgroundColor2, borderWidth: 0};

  return (
    <View style={{...styles.rowViewWithoutShadow, margin: 7, ...style}}>
      {buttons?.map((button, index) => {
        //const sty={...st, ...(isSelected ? {} : undefined)}
        const isSelected = selectedIndexes
          ? selectedIndexes.includes(index)
          : selectedIndex === index;
        const style2 = {
          ...(buttons.length === 1
            ? st
            : index === 0
            ? {
                borderRadius: 0,
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
                borderBottomLeftRadius: borderRadius,
                borderTopLeftRadius: borderRadius,
                borderRightWidth: 1,
                borderColor: backgroundColor4,
                ...st,
              }
            : index === buttons.length - 1
            ? {
                borderRadius: 0,
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
                borderBottomRightRadius: borderRadius,
                borderTopRightRadius: borderRadius,
                ...st,
              }
            : {
                borderRadius: 0,
                ...st,
                borderRightWidth: 1,
                borderColor: backgroundColor4,
              }),
          width: 100 / buttons.length + '%',
          ...zero_padding_margin,
        };
        return (
          <Button
            {...props}
            {...getMenuOptionProps()}
            accessoryLeft={accessoryLeft && accessoryLeft[index]}
            accessoryRight={accessoryRight && accessoryRight[index]}
            style={{...style2}}
            status={isSelected ? selectedStatus : status}
            onPress={() => {
              onPress && onPress(index);
            }}>
            {button}
          </Button>
        );
      })}
    </View>
  );
};

const runWithinTime = async (
  calculateData,
  calculation_Delay,
  startTime,
  calculationTimeoutID,
  onCalculationTimeSet,
  onTimeoutSet,
) => {
  let t1 = startTime ? startTime : 0;
  let t2 = Date.now();
  clearTimeout(calculationTimeoutID);
  if (t2 - t1 >= calculation_Delay) {
    await calculateData();
    startTime = t2;
    onCalculationTimeSet && onCalculationTimeSet(startTime);
  } else {
    calculationTimeoutID = setTimeout(calculateData, calculation_Delay);
    onTimeoutSet && onTimeoutSet(calculationTimeoutID);
  }
};

const List2 = (props: {
  noDivider?: boolean,
  doNotScrollToBottom?: boolean,
  data: any[],
  renderItem: ({item: any, index: number}) => any,
  onEndReached?: () => void,
  scrollRef?: any,
  floatingElements?: any,
  onScroll?: (e: NativeEvent) => void,
  onContentSizeChange?: (e: NativeEvent) => void,
  style?: ViewStyle,
}) => {
  let [state, setState] = useState({
    v: {isMessagesAtEnd: true, floatingElementsVisible: true},
  });
  const {
    noDivider,
    doNotScrollToBottom,
    data,
    onEndReached,
    floatingElements,
    onScroll,
    onContentSizeChange,
    scrollRef,
    style,
  } = props;
  const listRef = useRef();
  const setStateValue = async () => {
    await setState({...state});
  };
  useEffect(() => {
    if (scrollRef) scrollRef.current = listRef.current;
  }, [scrollRef, listRef.current]);
  return (
    <>
      <List
        ListHeaderComponent={noDivider ? undefined : <Divider />}
        ListFooterComponent={noDivider ? undefined : <Divider />}
        ItemSeparatorComponent={noDivider ? undefined : Divider}
        scrollEventThrottle={500}
        keyboardShouldPersistTaps={'handled'}
        {...props}
        ref={listRef}
        onScroll={
          doNotScrollToBottom && !onEndReached && !floatingElements
            ? onScroll
            : e => {
                if (!doNotScrollToBottom || onEndReached) {
                  state.v.isMessagesAtEnd = isScrollViewCloseToBottom(e);
                  state.v.isMessagesAtEnd &&
                    onEndReached &&
                    onEndReached(state.v.isMessagesAtEnd);
                }

                if (floatingElements) {
                  const currentOffset = e.nativeEvent.contentOffset.y;
                  if (!state.v.isInAnimationProcess) {
                    const dif = currentOffset - (state.v.offset || 0);

                    let scrollingUP = currentOffset > 0 && dif < 0;
                    if (scrollingUP) {
                      state.v.floatingElementsVisible = scrollingUP;
                      state.v.animationProps = {
                        animation: 'fadeInUp',
                        duration: 500,
                        direction: 'normal',
                        iterationCount: 1,
                        onAnimationBegin: () => {
                          state.v.isInAnimationProcess = true;
                        },
                        onAnimationEnd: () => {
                          state.v.isInAnimationProcess = undefined;
                        },
                      };
                    } else {
                      state.v.animationProps = {
                        animation: 'fadeOutDown',
                        duration: 500,
                        direction: 'normal',
                        iterationCount: 1,
                        onAnimationBegin: () => {
                          state.v.isInAnimationProcess = true;
                        },
                        onAnimationEnd: () => {
                          state.v.floatingElementsVisible = undefined;
                          state.v.isInAnimationProcess = undefined;
                          setStateValue();
                        },
                      };
                    }
                    setStateValue();
                  }
                  state.v.offset = currentOffset;
                }

                onScroll && onScroll(e);
              }
        }
        onContentSizeChange={
          doNotScrollToBottom
            ? onContentSizeChange
            : e => {
                let b = state.v.isMessagesAtEnd;
                if (b) {
                  setTimeout(() => listRef.current?.scrollToEnd(), 1000);
                }
                onContentSizeChange && onContentSizeChange(e);
              }
        }
      />
      {floatingElements && state.v.floatingElementsVisible && (
        <Animatable.View
          style={{position: 'absolute', bottom: 10, right: 10}}
          {...state.v.animationProps}>
          {floatingElements}
        </Animatable.View>
      )}
    </>
  );
};

function convertUndefinedToNull(obj) {
  if (obj) {
    for (const k in obj) {
      if (obj[k] === undefined) obj[k] = null;
    }
  }
  return obj;
}

function isFunction(component) {
  return typeof component === 'function';
}

function ShowInfo(props: {
  style?: ViewStyle,
  titleStyle?: TextStyle,
  infoStyle?: TextStyle,
  title: string,
  info: string,
  onPress?: () => void,
  divider?: string,
  status?: EvaStatus,
  infoStatus?: EvaStatus,
  accessoryLeft?: (props => ReactElement) | ReactElement,
  accessoryRight?: (props => ReactElement) | ReactElement,
  category?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 's1'
    | 's2'
    | 'p1'
    | 'p2'
    | 'c1'
    | 'c2'
    | 'label',
  infoCategory?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 's1'
    | 's2'
    | 'p1'
    | 'p2'
    | 'c1'
    | 'c2'
    | 'label',
  flexRatio?: number,
  noFlex?: boolean,
}) {
  let {
    style,
    titleStyle,
    infoStyle,
    title,
    info,
    onPress,
    divider,
    status,
    infoStatus,
    accessoryLeft,
    accessoryRight,
    category,
    infoCategory,
    flexRatio,
    noFlex,
  } = props;
  const st = {margin: 7, tintColor: backgroundColor4};
  //if (!checkValue(status)) status = 'info';
  //if (!checkValue(infoStatus)) infoStatus = 'primary';
  if (!checkValue(category)) category = 's1';
  if (!checkValue(infoCategory)) infoCategory = category;
  if (!isNumeric(flexRatio)) flexRatio = 0.45;
  if (flexRatio > 1) flexRatio = 1;
  if (flexRatio < 0) flexRatio = 0;
  //log(status + ' ' + infoStatus + ' ' + category + ' ' + infoCategory);
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={!onPress}
      {...props}
      style={{flexDirection: 'row', margin: 7, alignItems: 'center', ...style}}>
      <View
        style={{
          flex: noFlex ? undefined : flexRatio,
          ...styles.rowViewWithoutShadow,
          height: '100%',
        }}>
        {isFunction(accessoryLeft)
          ? accessoryLeft({style: st})
          : accessoryLeft &&
            React.cloneElement(accessoryLeft, {
              style: {...st, ...accessoryLeft.props.style},
            })}
        {checkValue(title) && (
          <Text
            appearance={'hint'}
            {...deleteUndefinedAndNull({status, category})}
            style={{...titleStyle, flex: noFlex ? undefined : 1}}>
            {title + (checkValue(divider) ? divider : ': ')}
          </Text>
        )}
      </View>
      <View
        style={{
          flex: noFlex ? undefined : 1 - flexRatio,
          ...styles.rowViewWithoutShadow,
          height: '100%',
        }}>
        {checkValue(info) && (
          <Text
            {...deleteUndefinedAndNull({
              status: infoStatus,
              category: infoCategory,
            })}
            style={{...infoStyle, flex: noFlex ? undefined : 1}}>
            {info}
          </Text>
        )}
        {isFunction(accessoryRight)
          ? accessoryRight({style: st})
          : accessoryRight &&
            React.cloneElement(accessoryRight, {
              style: {...st, ...accessoryRight.props.style},
            })}
      </View>
    </TouchableOpacity>
  );
}

const isScrollViewCloseToBottom = (e, horizontal) => {
  try {
    const {layoutMeasurement, contentOffset, contentSize} = e.nativeEvent;
    const padding = 20;
    if (horizontal)
      return (
        layoutMeasurement.width + contentOffset.x >= contentSize.width - padding
      );
    return (
      layoutMeasurement.height + contentOffset.y >= contentSize.height - padding
    );
  } catch (e) {}
  return false;
};

function Indicator(props) {
  let {pages, currentPageIndex, onDotClicked} = props;
  if (!pages) return null;
  if (!currentPageIndex) currentPageIndex = 0;
  return (
    <View
      style={{
        ...styles.rowViewWithoutShadow,
        //backgroundColor: transparent,
        justifyContent: 'center',
        margin: 10,
        ...props.style,
      }}>
      {Array(pages)
        .fill('0')
        .map((v, i) => {
          return (
            <TouchableOpacity
              onPress={() => {
                onDotClicked && onDotClicked(i);
              }}
              key={i}
              style={{
                ...shadow,
                borderRadius: 10,
                width: 10,
                height: 10,
                backgroundColor:
                  i === currentPageIndex ? secondaryColor : backgroundColor4,
                marginHorizontal: 5,
              }}
            />
          );
        })}
    </View>
  );
}

function sToHMS(seconds, showMilliseconds) {
  // 1- Extract hours:
  let hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
  seconds = seconds % 3600; // seconds remaining after extracting hours
  // 2- Extract minutes:
  let minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
  // 3- Keep only seconds not extracted to minutes:
  seconds = showMilliseconds
    ? Number(seconds % 60).toFixed(2)
    : parseInt(seconds % 60);
  return [hours, minutes, seconds];
}

function msToHMS(ms) {
  // 1- Convert to seconds:
  let [hours, minutes, seconds] = sToHMS(ms / 1000);
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  return hours + ':' + minutes + ':' + seconds;
}

const sToHMSText = (sec, doNotShowHour, doNotShowMinute, doNotShowSecond) => {
  const [h, m, s] = sToHMS(sec);
  return (
    (doNotShowHour ? '' : h ? h + ' h ' : '') +
    (doNotShowMinute ? '' : m ? m + ' m ' : '') +
    (doNotShowSecond ? '' : checkValue(s) ? s + ' s ' : '')
  );
};
const getObjectFromJsonArray = jsonArray => {
  let header = jsonArray[0];
  jsonArray.splice(0, 1);

  const jsonData = {};
  for (let jsd of jsonArray) {
    for (let i = 0; i < header.length; i++) {
      let key = header[i];
      key = key.trim();
      if (!jsonData[key]) jsonData[key] = [];
      let v = jsd[i];
      if (!isEmpty(v)) jsonData[key].push(v.trim());
    }
  }
  return jsonData;
};
// eslint-disable-next-line no-extend-native
Array.prototype.insert = function (item, before) {
  if (before == null || before < 0 || before > this.length - 1) {
    this.push(item);
    return;
  }
  this.splice(before, 0, item);
};

// eslint-disable-next-line no-extend-native
Array.prototype.remove = function (item) {
  let findIndex = this.findIndex(a => a === item);
  if (findIndex !== -1) {
    this.splice(findIndex, 1);
    return true;
  }
  return false;
};

const minimumSidePixelPercent =
  Math.min(Dimensions.get('window').height, Dimensions.get('window').width) /
  100;

function getPercentSize(percent) {
  return minimumSidePixelPercent * percent;
}

const zero_padding_margin = {
  padding: 0,
  margin: 0,
  marginBottom: 0,
  marginTop: 0,
  marginStart: 0,
  marginLeft: 0,
  marginRight: 0,
  marginEnd: 0,
  marginVertical: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  paddingEnd: 0,
  paddingStart: 0,
  paddingHorizontal: 0,
};

const Color = {
  BLUE2: {
    100: '#F2F6FF',
    200: '#D9E4FF',
    300: '#A6C1FF',
    400: '#598BFF',
    500: '#3366FF',
    600: '#274BDB',
    700: '#1A34B8',
    800: '#102694',
    900: '#091C7A',
  },
  BLUE3: {
    100: '#D5F1FB',
    200: '#ADDFF7',
    300: '#7FC1E8',
    400: '#5B9FD1',
    500: '#2D73B3',
    600: '#205999',
    700: '#164380',
    800: '#0E2F67',
    900: '#082055',
  },
  LIGHTBLUE2: {
    100: '#F2F8FF',
    200: '#C7E2FF',
    300: '#94CBFF',
    400: '#42AAFF',
    500: '#0095FF',
    600: '#006FD6',
    700: '#0057C2',
    800: '#0041A8',
    900: '#002885',
  },
  GREEN2: {
    100: '#EDFFF3',
    200: '#B3FFD6',
    300: '#8CFAC7',
    400: '#51F0B0',
    500: '#00E096',
    600: '#00B383',
    700: '#008F72',
    800: '#007566',
    900: '#00524C',
  },
  ORANGE2: {
    100: '#FFFDF2',
    200: '#FFF1C2',
    300: '#FFE59E',
    400: '#FFC94D',
    500: '#FFAA00',
    600: '#DB8B00',
    700: '#B86E00',
    800: '#945400',
    900: '#703C00',
  },
  RED2: {
    100: '#FFF2F2',
    200: '#FFD6D9',
    300: '#FFA8B4',
    400: '#FF708D',
    500: '#FF3D71',
    600: '#DB2C66',
    700: '#B81D5B',
    800: '#94124E',
    900: '#700940',
  },
  GREY2: {
    100: '#FFFFFF',
    200: '#F7F9FC',
    300: '#EDF1F7',
    400: '#E4E9F2',
    500: '#C5CEE0',
    600: '#8F9BB3',
    700: '#2E3A59',
    800: '#222B45',
    900: '#1A2138',
    1000: '#151A30',
    1100: '#101426',
  },
  WHITE: {
    100: '#FFFFFF',
    200: '#FFFFFF',
    300: '#FFFFFF',
    400: '#FFFFFF',
    500: '#FFFFFF',
    600: '#DBBABD',
    700: '#B7808A',
    800: '#935162',
    900: '#7A304A',
  },
  BLACK: {
    100: '#F2F2F2',
    200: '#E5E5E5',
    300: '#B2B2B2',
    400: '#666666',
    500: '#000000',
    600: '#000000',
    700: '#000000',
    800: '#000000',
    900: '#000000',
  },
  DELTAGREY: {
    50: '#e4e4e4',
    100: '#bdbdbd',
    200: '#a1a1a1',
    300: '#7e7e7e',
    400: '#6e6e6e',
    500: '#5f5f5f',
    600: '#505050',
    700: '#404040',
    800: '#313131',
    900: '#222222',
    1000: '#e4e4e4',
    1100: '#bdbdbd',
    A400: '#6e6e6e',
    A700: '#404040',
  },
  DELTABLUE: {
    50: '#e6f5ff',
    100: '#9ad8ff',
    200: '#62c2ff',
    300: '#1aa7ff',
    400: '#009afb',
    500: '#0087dc',
    600: '#0074bd',
    700: '#00619f',
    800: '#004f80',
    900: '#003c62',
    1000: '#e6f5ff',
    1100: '#9ad8ff',
    A400: '#009afb',
    A700: '#00619f',
  },
  DELTAORANGE: {
    50: '#FFFDFA',
    100: '#FFDAAE',
    200: '#FFC076',
    300: '#FF9F2E',
    400: '#FF9110',
    500: '#F08200',
    600: '#D17100',
    700: '#B36100',
    800: '#945000',
    900: '#764000',
    1000: '#FFFDFA',
    1100: '#FFDAAE',
    A400: '#FF9110',
    A700: '#B36100',
  },
  DELTAGREEN: {
    50: '#C5F8CD',
    100: '#81EF91',
    200: '#50E965',
    300: '#1BD636',
    400: '#17BB2F',
    500: '#14A028',
    600: '#118521',
    700: '#0D6A1A',
    800: '#0A4E14',
    900: '#06330D',
    1000: '#C5F8CD',
    1100: '#81EF91',
    A400: '#17BB2F',
    A700: '#0D6A1A',
  },
  RED: {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    1000: '#ff8a80',
    1100: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000',
  },
  PINK: {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    1000: '#ff80ab',
    1100: '#ff4081',
    A400: '#f50057',
    A700: '#c51162',
  },
  PURPLE: {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    1000: '#ea80fc',
    1100: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff',
  },
  DEEPPRUPLE: {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512DA8',
    800: '#4527A0',
    900: '#311B92',
    1000: '#b388ff',
    1100: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea',
  },
  INDIGO: {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303F9F',
    800: '#283593',
    900: '#1A237E',
    1000: '#8c9eff',
    1100: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe',
  },
  BLUE: {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    1000: '#82b1ff',
    1100: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff',
  },
  LIGHTBLUE: {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    1000: '#80d8ff',
    1100: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea',
  },
  CYAN: {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    1000: '#84ffff',
    1100: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4',
  },
  TEAL: {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    1000: '#a7ffeb',
    1100: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5',
  },
  GREEN: {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    1000: '#b9f6ca',
    1100: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853',
  },
  LIGHTGREEN: {
    50: '#f1f8e9',
    100: '#dcedc8',
    200: '#c5e1a5',
    300: '#aed581',
    400: '#9ccc65',
    500: '#8bc34a',
    600: '#7cb342',
    700: '#689f38',
    800: '#558b2f',
    900: '#33691e',
    1000: '#ccff90',
    1100: '#b2ff59',
    A400: '#76ff03',
    A700: '#64dd17',
  },
  LIME: {
    50: '#f9fbe7',
    100: '#f0f4c3',
    200: '#e6ee9c',
    300: '#dce775',
    400: '#d4e157',
    500: '#cddc39',
    600: '#c0ca33',
    700: '#afb42b',
    800: '#9e9d24',
    900: '#827717',
    1000: '#f4ff81',
    1100: '#eeff41',
    A400: '#c6ff00',
    A700: '#aeea00',
  },
  YELLOW: {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    1000: '#ffff8d',
    1100: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600',
  },
  AMBER: {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    1000: '#ffe57f',
    1100: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00',
  },
  ORANGE: {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    1000: '#ffd180',
    1100: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00',
  },
  DEEPORANGE: {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    1000: '#ff9e80',
    1100: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00',
  },
  BROWN: {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    1000: '#ece2df',
    1100: '#cfb7af',
    A400: '#8c6253',
    A700: '#533a31',
  },
  BLUEGREY: {
    50: '#eceff1',
    100: '#cfd8dc',
    200: '#b0bec5',
    300: '#90a4ae',
    400: '#78909c',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
    1000: '#f9fafb',
    1100: '#ccd7dc',
    A400: '#6e8d9b',
    A700: '#475c67',
  },
  GREY: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    1000: '#ffffff',
    1100: '#fcfcfc',
    A400: '#adadad',
    A700: '#7f7f7f',
  },
};

const colorCategories = [
  'primary',
  'info',
  'success',
  'warning',
  'danger',
  'basic',
];
const otherColorCategories = [
  'sideMenuBackgroundColor',
  'mainContentBackgroundColor',
  'headerBarBackgroundColor',
];
const colorLevels = [
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '1000',
  '1100',
];

const generateStyles = () => {
  const theme = eva[themeName];

  primaryColor = theme[theme['color-primary-default'].substr(1)];
  secondaryColor = theme[theme['color-info-default'].substr(1)];
  thirdColor = theme[theme['color-success-default'].substr(1)];
  fourthColor = theme[theme['color-warning-default'].substr(1)];
  fifthColor = theme[theme['color-danger-default'].substr(1)];
  backgroundColor1 = theme[theme['background-basic-color-1'].substr(1)];
  backgroundColor2 = theme[theme['background-basic-color-2'].substr(1)];
  backgroundColor3 = theme[theme['background-basic-color-3'].substr(1)];
  backgroundColor4 = theme[theme['background-basic-color-4'].substr(1)];
  backgroundColor5 = themeName === 'light' ? 'black' : 'white';
  semiTransparent = backgroundColor1 + '88';
  shadow = {
    // backgroundColor: backgroundColor1,
    shadowColor: backgroundColor4,
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.4,
    shadowRadius: 4,
    elevation: 5,
    overflow: 'hidden',
    borderWidth: 2,
    borderColor: backgroundColor4,
    // borderRadius: 10,
    // borderColor: primaryColor,
    // borderWidth: 1,
  };
  antiShadow = Object.keys(shadow).reduce((pv, cv) => {
    pv[cv] = undefined;
    return pv;
  }, {});
  styles = {
    shadow: shadow,
    scrollViewContentContainerStyle: {
      flexGrow: 1,
      justifyContent: 'center',
    },
    rowView: {
      ...shadow,
      // padding: 2,
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flexWrap: 'wrap',
      alignContent: 'space-around',
      //alignContent: 'stretch',
      // justifyContent: 'space-evenly',
    },
    columnView: {
      ...shadow,
      // padding: 2,
      justifyContent: 'space-evenly',
      //alignItems: 'center',
    },
    rowViewWithoutShadow: {
      // padding: 2,
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flexWrap: 'wrap',
      alignContent: 'space-around',
      // alignContent: 'stretch',
      // justifyContent: 'space-evenly',
    },
    columnViewWithoutShadow: {
      //  padding: 2,
      justifyContent: 'space-evenly',
      //alignItems: 'center',
    },
  };
};

const generateColorsAndStyles = async () => {
  let selectedColors = await retrieveUserSession('selectedColors-' + themeName);
  if (selectedColors) selectedColors = JSON.parse(selectedColors);
  if (themeName === 'dark') {
    Object.assign(defaultColors, otherDefaultColors2);
  } else {
    Object.assign(defaultColors, otherDefaultColors);
  }
  selectedColors = {
    ...defaultColors,
    ...selectedColors,
  };
  GlobalState.v.selectedColors = selectedColors;

  const colors = {};
  colorCategories.forEach(category => {
    let colorSet = Color[selectedColors[category]];
    colorLevels.forEach(level => {
      if (colorSet && colorSet[level])
        colors['color-' + category + '-' + level] = colorSet[level];
    });
  });

  const theme = eva[themeName];
  Object.assign(theme, colors);
  // log(theme, false, true);

  generateStyles();
};

generateStyles();

function capitalizeFirstLetter(string) {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
}

const getTitleFromName = name => {
  if (name) {
    const parts = [0];

    for (let i = 0; i < name.length; i++) {
      let preI = i - 1;
      const previousLetter = name.charAt(preI);
      if (!previousLetter) continue;
      const currentLetter = name.charAt(i);

      const isPreCapital = previousLetter === previousLetter.toUpperCase();
      const isCurrentCapital = currentLetter === currentLetter.toUpperCase();

      if (isPreCapital && !isCurrentCapital) {
        if (!parts.includes(preI)) parts.push(preI);
      } else if (!isPreCapital && isCurrentCapital) {
        if (!parts.includes(i)) parts.push(i);
      }
    }

    parts.sort((a, b) => a - b);
    let names = [];
    for (let i = 0; i < parts.length; i++) {
      let index = parts[i];
      let nextIndex = parts[i + 1];
      if (!checkValue(nextIndex)) nextIndex = name.length;
      names.push(name.substring(index, nextIndex));
    }
    //log(parts);
    //log(names);
    return names
      .map(n => {
        return n
          .split('_')
          .map(nam => capitalizeFirstLetter(nam))
          .join(' ')
          .trim();
      })
      .join(' ');
  }
};

function reverseString(s) {
  return s.split('').reverse().join('');
}

function formatStringToLength(str, length, prefix = '0') {
  if (length < str.length) {
    return str.substr(0, length);
    //return str.substring(str.length - length);
    //return str;
  }
  const s = prefix.repeat(length / prefix.length);
  const v = s + str;
  return v.substring(v.length - length);
}

const getTexts = (dataObject, keyObject, category = 's1', divider) => {
  let hasPreviousValue;
  return (
    <>
      {Object.keys(keyObject).map((key, index) => {
        const value = keyObject[key];
        const {formatter, title} = value ? value : {};

        const v = formatter ? formatter(dataObject[key]) : dataObject[key];
        if (!checkValue(v)) {
          return;
        }

        const t = checkValue(title) ? title : capitalizeFirstLetter(key);
        const d = hasPreviousValue && divider;

        hasPreviousValue = true;
        return (
          <>
            {d}
            <Text status={'info'} category={category}>
              {t + ': '}
              <Text status={'primary'} category={category}>
                {v}
              </Text>
            </Text>
          </>
        );
      })}
    </>
  );
};

const formatAMPM = (date, doNotShowSeconds) => {
  if (!date) {
    date = new Date();
  } else if (!(date instanceof Date)) date = new Date(date);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  if (!doNotShowSeconds) {
    let seconds = date.getSeconds();
    seconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${hours}:${minutes}:${seconds} ${ampm}`;
  } else return `${hours}:${minutes} ${ampm}`;
};

function parseDateDDMMYYYY(DDMMYYYY) {
  if (isEmpty(DDMMYYYY)) {
    return undefined;
  }
  let s = DDMMYYYY.split('/');
  let d = new Date(s[2], s[1] - 1, s[0]);
  return d;
}

function getDateDDMMYYYY(milliseconds) {
  if (milliseconds === undefined || milliseconds === null) {
    return undefined;
  }
  let date = new Date(milliseconds);
  let d = date.getDate();
  d = d < 10 ? '0' + d : d;
  let m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  return d + '/' + m + '/' + date.getFullYear();
}

function isClassComponent(component) {
  return (
    typeof component === 'function' && !!component.prototype.isReactComponent
  );
}

function isFunctionComponent(component) {
  return (
    typeof component === 'function' &&
    String(component).includes('return React.createElement')
  );
}

function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
}

function isElement(element) {
  return React.isValidElement(element);
}

function isDOMTypeElement(element) {
  return isElement(element) && typeof element.type === 'string';
}

function isCompositeTypeElement(element) {
  return isElement(element) && typeof element.type === 'function';
}

const includeRangeDate = (startEndDate, data) => {
  if (startEndDate.range) {
    if (startEndDate.range.startDate) {
      data.startDate = new Date(startEndDate.range.startDate);
      data.startDate.setHours(0, 0, 0, 0);
    }
    if (startEndDate.range.endDate) {
      data.endDate = new Date(startEndDate.range.endDate);
      data.endDate.setHours(23, 59, 0, 0);
    } else if (data.startDate) {
      data.endDate = new Date(data.startDate);
      data.endDate.setHours(23, 59, 0, 0);
    }
  }
  return data;
};

const AnimatedIcon = props => {
  let {ref, animation, style, name} = props;
  if (!animation) {
    animation = 'pulse';
  }
  if (!style) {
    style = {width: 25, height: 25, tintColor: secondaryColor};
  } else {
    style = {width: 25, height: 25, tintColor: secondaryColor, ...style};
  }
  const [state, setState] = useState({v: {}});
  useEffect(() => {
    if (state.v.ref) {
      if (state.v.hover) {
        state.v.ref.startAnimation();
      }
      // else state.v.ref.stopAnimation();
    }
  }, [!!state.v.ref, state.v.hover]);
  return (
    <Icon
      onMouseEnter={() => {
        state.v.hover = true;
        setState({...state});
      }}
      onMouseLeave={() => {
        state.v.hover = false;
        setState({...state});
      }}
      {...props}
      key={name}
      style={style}
      ref={ref1 => {
        if (ref) {
          ref(ref1);
        }
        state.v.ref = ref1;
        // if (ref1) ref1.startAnimation();
      }}
    />
  );
};

const AutoWidthLayout = props => {
  const {style, children, states} = props;
  const ref = useRef();
  if (states) {
    states.animationRef = ref;
  }
  return (
    <Animatable.View
      {...props}
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        margin: 7,
        ...style,
      }}
      ref={ref}>
      {children}
    </Animatable.View>
  );
};

function showYesNoDialog(
  headerText,
  subHeaderText,
  yesText,
  noText,
  onYesPress,
  onNoPress,
  time,
  doNotHide,
) {
  flashMessage.showMessage({
    message: headerText,
    subMessage: subHeaderText,
    time,
    doNotHide,
    content: (
      <View style={{...styles.rowViewWithoutShadow}}>
        {onYesPress ? (
          <AutoWidthLayout>
            <Button
              onPress={() => {
                onYesPress && onYesPress();
              }}
              PULSE
              status={'primary'}
              accessoryRight={
                <AnimatedIcon animation="shake" name="checkmark-circle-2" />
              }>
              {yesText}
            </Button>
          </AutoWidthLayout>
        ) : undefined}
        {onNoPress ? (
          <AutoWidthLayout>
            <Button
              status={'basic'}
              onPress={() => {
                onNoPress && onNoPress();
              }}
              accessoryRight={
                <AnimatedIcon animation="shake" name="close-circle" />
              }
              PULSE>
              {noText}
            </Button>
          </AutoWidthLayout>
        ) : undefined}
      </View>
    ),
  });
}

const getTime = () => {
  const date = new Date();
  return (
    checkTimeAddZero(date.getHours()) +
    ':' +
    checkTimeAddZero(date.getMinutes())
  );
};

function checkTimeAddZero(i) {
  if (i < 10) {
    i = '0' + i;
  }
  return i;
}

const TimeText = (props: {...TextProps, formatter: () => string}) => {
  const {formatter} = props;
  let [state, setState] = useState({v: {}});
  useEffect(() => {
    if (state.v.timer) clearTimeout(state.v.timer);
    const date = new Date();
    let sec = 60 - date.getSeconds();
    state.v.timer = setTimeout(() => {
      setState({...state});
    }, sec * 1000);
    return () => {
      clearTimeout(state.v.timer);
    };
  });
  return <Text {...props}>{formatter ? formatter() : getTime()}</Text>;
};

function getFormattedDateTime(
  milliseconds,
  onlyDate,
  doNotShowSeconds,
  doNotShowDaySpecifier,
) {
  if (milliseconds === undefined || milliseconds === null) {
    return 'Unknown';
  }
  let today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);
  let compDate = new Date(milliseconds); // month - 1 because January == 0
  let cd = compDate.getTime();
  let td = today.getTime();
  let diff = cd - td; // get the difference between the date and today(at 00:00:00)
  let diff2 = -diff; // get the difference between today(at 00:00:00) and the date
  let TFH = 86400000;
  if (!doNotShowDaySpecifier) {
    if (diff >= 0 && diff < TFH) {
      return (
        'Today' +
        (onlyDate ? '' : ' at ' + formatAMPM(compDate, doNotShowSeconds))
      );
    } else if (diff2 > 0 && diff2 <= TFH) {
      return (
        'Yesterday' +
        (onlyDate ? '' : ' at ' + formatAMPM(compDate, doNotShowSeconds))
      );
    } else if (diff >= 0 && diff >= TFH && diff <= 2 * TFH) {
      return (
        'Tomorrow' +
        (onlyDate ? '' : ' at ' + formatAMPM(compDate, doNotShowSeconds))
      );
    }
  }
  //return compDate.toDateString(); // or format it what ever way you want
  let year = compDate.getFullYear();
  let month = compDate.getMonth();
  let months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  let day = compDate.getDate();
  let d = compDate.getDay();
  let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  //alert(formattedDate);
  return (
    days[d] +
    ' ' +
    day +
    ' ' +
    months[month] +
    ' ' +
    year +
    (onlyDate ? '' : ' at ' + formatAMPM(compDate, doNotShowSeconds))
  );
}

/**
 * Get the week number of the month, from "First" to "Last"
 * @param {Date} date
 * @returns {string}
 */
function weekOfTheMonth(date) {
  const day = date.getDate();
  const weekDay = date.getDay();
  let week = Math.ceil(day / 7);

  //const ordinal = ['First', 'Second', 'Third', 'Fourth', 'Last']
  //const weekDays  = ['Sunday','Monday','Tuesday','Wednesday', 'Thursday','Friday','Saturday']

  // Check the next day of the week and if it' on the same month, if not, respond with "Last"
  const nextWeekDay = new Date(date.getTime() + 1000 * 60 * 60 * 24 * 7);
  if (nextWeekDay.getMonth() !== date.getMonth()) {
    week = 5;
  }

  //return `${ordinal[week - 1]} ${weekDays[weekDay]}`
  return week;
}

let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
/**
 *
 * @param date {Date}
 * @param day {'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'} Required
 * @param hour 0 to 23
 * @param minute 0 to 60
 * @param weekNumbers {[1, 2, 3, 4, 5]}
 * @returns {Date | Date}
 */
let getDateForWeekDay = (date, day, hour, minute, weekNumbers) => {
  let dis = days.indexOf(day) - date.getDay();
  if (dis <= 0) {
    let b = true;
    if (dis === 0) {
      if (date.getHours() * 60 + date.getMinutes() < hour * 60 + minute) {
        b = false;
      }
    }
    if (b) {
      dis = 7 + dis;
    }
  }
  date.setDate(date.getDate() + dis);
  date.setHours(hour, minute, 0, 0);
  if (weekNumbers) {
    weekNumbers.sort();
    let currentWeek = weekOfTheMonth(date);
    log('cureent week - ' + currentWeek);
    let weekDis;
    let noNeed = weekNumbers.some((targetWeek, index) => {
      let d = targetWeek - currentWeek;
      if (d >= 0) {
        weekDis = d;
        return true;
      }
    });

    if (!noNeed) {
      date.setMonth(date.getMonth() + 1);
      date.setDate(1);
      return getDateForWeekDay(date, day, hour, minute, weekNumbers);
    } else {
      date.setDate(date.getDate() + 7 * weekDis);
    }
  }
  return date;
};

function getAgeInYearMonthDay(date) {
  return getDifferenceInYearMonthDay(date, new Date());
}

function getDifferenceInYearMonthDay(pastDate, futureDate) {
  if (!pastDate || !(pastDate instanceof Date)) {
    return [0, 0, 0];
  }
  if (!futureDate || !(futureDate instanceof Date)) {
    return [0, 0, 0];
  }
  futureDate.setHours(0, 0, 0, 0);
  // Example date of birth.
  pastDate.setHours(0, 0, 0, 0);

  let years = futureDate.getFullYear() - pastDate.getFullYear();
  let months = futureDate.getMonth() - pastDate.getMonth();
  let days = futureDate.getDate() - pastDate.getDate();

  // Work out the difference in months.
  months += years * 12;
  if (days < 0) {
    months -= 1;
  }
  // Now add those months to the date of birth.
  pastDate.setMonth(pastDate.getMonth() + months);
  // Calculate the difference in milliseconds.
  const diff = futureDate - pastDate;
  // Divide that by 86400 to get the number of days.
  days = Math.round(diff / 86400 / 1000);
  // Now convert months back to years and months.
  years = parseInt(months / 12);
  months -= years * 12;
  // log(dobDate);
  // log([years, months, days]);
  return [years, months, days];
}

function getAgeText(date) {
  const age = getAgeInYearMonthDay(date);
  return getAgeText2(age);
}

function getAgeText2([years, months, days]) {
  // Format age as "xx years, yy months, zz days"
  let text = '';
  if (years) {
    text = years + (years > 1 ? ' years' : ' year');
  }
  if (months) {
    if (text.length) {
      text = text + ', ';
    }
    text = text + months + (months > 1 ? ' months' : ' month');
  }
  if (days) {
    if (text.length) {
      text = text + ', ';
    }
    text = text + days + (days > 1 ? ' days' : ' day');
  }
  /*if (!text) {
        text = "Newborn";
      }*/
  return text;
}

const LoadingIndicator = props => {
  let {size} = props;
  if (!size) size = 'medium';

  return (
    <View style={[props.style, styles.columnViewWithoutShadow]}>
      <Spinner size={size} />
    </View>
  );
};

const IconText = props => {
  let {icon, text} = props;
  return (
    <View style={styles.rowViewWithoutShadow}>
      {icon ? (
        isElement(icon) ? (
          icon
        ) : (
          <Icon style={{margin: 5}} {...icon} />
        )
      ) : undefined}
      <Text style={styles.contentTextWithoutShadow}>{text}</Text>
    </View>
  );
};

/*function UserManagement(props) {
  let [state, setState] = useState({v: {}});
  state.v.userListener = props.userListener;
  // Handle user state changes
  function onAuthStateChanged(user1) {
    database().setPersistenceEnabled(true);
    if (state.v.userListener) {
      state.v.userListener(user1);
    }
  }

  useEffect(() => {
    const subscriber = auth().onAuthStateChanged(onAuthStateChanged);
    return subscriber; // unsubscribe on unmount
  }, []);
  return null;
}
*/

function getOnlyDigits(string, allowNegative) {
  if (!string) {
    return string;
  }
  let k = string.replace(/\D/g, '');
  if (isNumeric(k)) {
    if (allowNegative) {
      if (string.startsWith('-')) {
        k = '-' + k;
      }
    }
    return k;
  } else if (string.trim() === '-') {
    return '-';
  }
}

function getNumbersAndPeriods2(string) {
  try {
    let hasPeriod = string.indexOf('.') === string.length - 1;
    let hasZero = string.lastIndexOf('0') === string.length - 1;

    let k = Number.parseFloat(string);
    k = String(k);
    if (k === 'NaN') {
      return '';
    }
    if (hasPeriod) {
      k += '.';
    }
    if (k.indexOf('.') !== -1 && hasZero) {
      k += '0';
    }
    return k;
  } catch (e) {
    console.log(e);
  }
  return undefined;
}

const digitPeriod = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];

function getNumbersAndPeriods(string, allowNegative) {
  try {
    let k = '';
    //let broken;
    for (let i = 0; i < string.length; i++) {
      //if (broken) continue;
      const char = string.charAt(i);
      if (digitPeriod.includes(char)) {
        k += char;
      } else if (k) {
        break;
      }
    }
    if (isNumeric(k)) {
      if (allowNegative) {
        if (string.startsWith('-')) {
          k = '-' + k;
        }
      }
      return k;
    } else if (string.trim() === '-') {
      return '-';
    }
  } catch (e) {
    console.log(e);
  }
  return undefined;
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function isEmpty(string) {
  if (!checkValue(string)) {
    return true;
  }
  string += '';
  return !string || string.trim() === '';
}

/*function notifyMessage2(msg) {
  if (Platform.OS === 'android') {
    ToastAndroid.show(msg, ToastAndroid.SHORT);
  } else {
    AlertIOS.alert(msg);
  }
}*/

/**
 *
 * @param message {string | ReactElement}
 * @param status {EvaStatus}
 */
const notify = (message, status = 'warning') => {
  notifyMessage(message, null, true, 5000, true, status);
};

/**
 *
 * @param msg {string | ReactElement}
 * @param description {string | ReactElement}
 * @param showAsOverlay {boolean}
 * @param time {number}
 * @param autoHide {boolean}
 * @param status {EvaStatus}
 * @param showFullScreen {boolean}
 * @param doNotScroll {boolean}
 */
function notifyMessage(
  msg,
  description,
  showAsOverlay,
  time,
  autoHide = true,
  status,
  showFullScreen,
  doNotScroll,
) {
  if (flashMessage?.showMessage) {
    flashMessage.showMessage({
      message: msg,
      subMessage: description,
      showAsOverlay,
      time,
      doNotHide: !autoHide,
      status,
      showFullScreen,
      doNotScroll,
    });
  }
}

function notifyCustomMessage(msg) {
  flashMessage.showMessage({content: msg});
  // showMessage(msg);
}

function notifyCustomMessage2(title, customView, autoHide, animated) {
  notifyCustomMessage({
    message: title,
    renderCustomContent: () => {
      return customView;
    },
    autoHide: autoHide,
    hideOnPress: autoHide,
    animated: animated,
  });
}

/*async function getResizedImage(
  image,
  original_width,
  original_height,
  callBack,
  required_size = 1000000,
) {
  try {
    let y = original_height,
      x = original_width;

    let reduction_x = x * 0.1;
    let reduction_y = y * 0.1;
    while (x > 4000 || y > 4000) {
      x -= reduction_x;
      y -= reduction_y;
    }
    let length_bmp;
    do {
      let response = await ImageResizer.createResizedImage(
        image,
        x,
        y,
        'JPEG',
        100,
        0,
        null,
        true,
        'contain',
        true,
      );
      // log(response);
      image = response.uri;
      length_bmp = response.size;
      x -= reduction_x;
      y -= reduction_y;
    } while (length_bmp > required_size && Math.min(x, y) > 100);
  } catch (ignored) {
    log(ignored);
  }
  callBack(image);
}*/

async function askPermissions(permissions, callBack) {
  return new Promise(resolve => {
    if (isAndroid) {
      PermissionsAndroid.requestMultiple(permissions).then(granted => {
        let result = Object.values(granted).filter(
          v => v !== PermissionsAndroid.RESULTS.GRANTED,
        );
        if (!result.length) {
          resolve(true);
          callBack && callBack();
        }
      });
    } else {
      resolve(true);
      callBack && callBack();
    }
  });
}

function isNumeric(str) {
  if (str === undefined || str === null) {
    return false;
  }
  //if (typeof str !== "string") return false // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

function notifyInputError(message, ref, showAsOverlay) {
  if (message) {
    notifyMessage(message, undefined, showAsOverlay);
  }
  if (ref) {
    ref.focus && ref.focus();
    ref.shake && ref.shake();
  }
}

/*function notifyInputError2(message, ref) {
  if (message) notifyMessage2(message);
  if (ref) {
    ref.focus && ref.focus();
    ref.shake && ref.shake();
  }
}*/

async function storeUserSession(key, object, onComplete) {
  let success;
  try {
    await AsyncStorage.setItem(key, object);
    if (onComplete) {
      onComplete((success = true));
    }
    // Congrats! You've just stored your first value!
  } catch (error) {
    //alert(error);
    // There was an error on the native side
    if (onComplete) {
      onComplete((success = false));
    }
  }
  return success;
}

async function retrieveUserSession(key, onComplete) {
  let session;
  try {
    session = await AsyncStorage.getItem(key);
    if (onComplete) {
      onComplete(session);
    }
  } catch (error) {
    // There was an error on the native side
    if (onComplete) {
      onComplete(null);
    }
  }
  return session;
}

async function removeUserSession(key, onComplete) {
  let success;
  try {
    await AsyncStorage.removeItem(key);
    if (onComplete) {
      onComplete((success = true));
    }
    // Congrats! You've just removed your first value!
  } catch (error) {
    // There was an error on the native side
    if (onComplete) {
      onComplete((success = false));
    }
  }
  return success;
}

async function clearStorage(onComplete) {
  try {
    await AsyncStorage.clear();
    if (onComplete) {
      onComplete(true);
    }
    // Congrats! You've just cleared the device storage!
  } catch (error) {
    // There was an error on the native side
    if (onComplete) {
      onComplete(false);
    }
  }
}

/**
 *
 * @param obj {string | {message:string} | any}
 * @param showInRelease {boolean}
 * @param doNotShowInDebug {boolean}
 * @param overlay {boolean}
 * @param time {number}
 * @param autoHide {boolean}
 * @param status {EvaStatus}
 * @param showFullScreen {boolean}
 */
function log(
  obj,
  showInRelease,
  doNotShowInDebug,
  overlay,
  time = 5000,
  autoHide,
  status = 'danger',
  showFullScreen,
) {
  const __DEV__ = process.env.NODE_ENV !== 'production';

  let data =
    typeof obj === 'string'
      ? obj
      : obj && obj.message
      ? obj.message
      : JSON.stringify(obj, undefined, '\t');
  console.log(data);
  if (showInRelease || (!doNotShowInDebug && __DEV__)) {
    notifyMessage(data, null, overlay, time, autoHide, status, showFullScreen);
  }
}

function checkValue(value) {
  return value !== undefined && value !== null;
}

const testing = true;
const isTesting = allowInProduction => {
  const __DEV__ = process.env.NODE_ENV !== 'production';
  return testing && (allowInProduction || __DEV__);
};

const Stack = createStackNavigator();
const openingScreen = 'Opening Screen';
const logoScreen = 'Log In';

/* Firebase related */
let userInfo;
const userAvailableListeners = [];

const defaultColors = {
  primary: 'BLUE2',
  info: 'LIGHTBLUE2',
  success: 'GREEN2',
  warning: 'ORANGE2',
  danger: 'RED2',
  basic: 'GREY2',
};
let otherDefaultColors = {
  sideMenuBackgroundColor: null,
  mainContentBackgroundColor: null,
  headerBarBackgroundColor: null,
};
let otherDefaultColors2 = {
  sideMenuBackgroundColor: null,
  mainContentBackgroundColor: null,
  headerBarBackgroundColor: null,
};
const getBackground = selectedColor => {
  let backgroundColor;
  if (selectedColor) {
    const [colorName, colorLevel] = selectedColor.split('-');
    let colorSet = Color[colorName];
    if (colorSet) {
      backgroundColor = colorSet[colorLevel];
    }
  }
  return backgroundColor;
};

const getDefaultGlobalState = () => ({
  v: {
    selectedColors: defaultColors,
    isNavigationDrawerExpanded: true,
  },
});
let GlobalState = getDefaultGlobalState();
const flashMessage = {};

function getFunctionData(functionElement) {
  return functionElement();
}
const convertObjectToString = obj => {
  let user = JSON.stringify(obj, undefined, ' ');
  if (user) {
    user = user.replace(/\r\n|\r|\n/g, '');
  }
  return user;
};
const cloudUrl = 'https://us-central1-' + project_id + '.cloudfunctions.net/';
const callCloud = (
  name,
  data,
  callBack,
  doNotShowError,
  customUrl,
  otherData,
) => {
  return new Promise(resolve => {
    fetch((checkValue(customUrl) ? customUrl : cloudUrl) + name, {
      ...otherData,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...otherData?.headers,
      },
      body: convertObjectToString({
        ...data,
        userTimeZoneOffset: new Date().getTimezoneOffset(),
        //...otherData?.body
      }),
    })
      .then(response => response.json())
      .then(json => {
        try {
          callBack && callBack(json);
          resolve(json);
        } catch (e) {
          if (!doNotShowError) log(e, true);
          resolve(e);
        }
      })
      .catch(error => {
        callBack && callBack(error);
        if (!doNotShowError) log(error, true);
        resolve(error);
      });
  });
};

const App = () => {
  const [state, setState] = useState(GlobalState);
  GlobalState = state;

  useEffect(() => {
    generateColorsAndStyles().then(() => {
      themeChangeListeners.forEach(lis => lis(themeName));
    });
  }, []);

  useEffect(() => {
    let lis = () => {
      setState({...state});
    };
    themeChangeListeners.push(lis);
    return () => {
      themeChangeListeners.remove(lis);
    };
  }, []);

  useEffect(() => {
    const lis = () => {
      themeChangeListeners.forEach(lis => lis());
    };
    const subscription = Dimensions.addEventListener('change', lis);
    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    setState({...state});
  }, [primaryColor]);

  return (
    <>
      <IconRegistry icons={EvaIconsPack} />
      <ApplicationProvider {...eva} theme={eva[themeName]}>
        <FlashMessage states={flashMessage}>
          <SafeAreaProvider>
            <Dashboard />
          </SafeAreaProvider>
        </FlashMessage>
      </ApplicationProvider>
    </>
  );
};

function Dashboard(props) {
  let [state, setState] = useState({
    v: {
      dashboardData: {
        DASHBOARD_NAME: 'RM SOLAAR PVT LTD',
        AMC_LOGO: 'https://www.esenz.live/images/AMC_LOGO/AMC_ID_39.png',
        NO_OF_INSTALLATIONS: '17',
        NO_OF_INVERTERS: '50',
        TOTAL_CAPACITY_DISPLAY: '3.8 MW',
        ENERGY_TOTAL_DISPLAY: '438 441 357',
        ENERGY_TODAY_DISPLAY: '001 358',
        ENERGY_YESTERDAY_DISPLAY: '008 615',
        CURRENT_POWER_DISPLAY: '1.2 MW',
        CURRENT_POWER_PERCENT: '32.9', // need to show the progress
        CURRENT_GAUGE_TOTAL_CAPACITY: '3691.7', // need to show the progress max value, min value is 0
        EFFECTIVE_TREES_PLANTED: '4 559 790',
        CO2_AVOIDED: '359 521 912',
        NON_COMM_SYSTEMS: '1',
        ALERTS: '2',
        time: 0,
      },
    },
  });
  const setStateValue = async () => {
    await setState({...state});
  };
  useEffect(() => {
    let lis = () => {
      setStateValue();
    };
    themeChangeListeners.push(lis);
    return () => {
      themeChangeListeners.remove(lis);
    };
  }, []);

  const {
    DASHBOARD_NAME,
    AMC_LOGO,
    NO_OF_INSTALLATIONS,
    NO_OF_INVERTERS,
    TOTAL_CAPACITY_DISPLAY,
    ENERGY_TOTAL_DISPLAY,
    ENERGY_TODAY_DISPLAY,
    ENERGY_YESTERDAY_DISPLAY,
    CURRENT_POWER_DISPLAY,
    CURRENT_POWER_PERCENT,
    CURRENT_GAUGE_TOTAL_CAPACITY,
    EFFECTIVE_TREES_PLANTED,
    CO2_AVOIDED,
    NON_COMM_SYSTEMS,
    ALERTS,
    time,
  } = state.v.dashboardData;

  useEffect(() => {
    callCloud('group1-getSavedData', undefined, data => {
      if (data?.data) {
        state.v.dashboardData = data.data;
        console.log(data.data);
        setStateValue();
      }
    });
  }, []);

  const rightLogo =
    'https://www.esenz.live/webPageImages/imageEsenzLogoSmall.png';

  const scaledWrapper = useRef();
  const scaledContent = useRef();

  useEffect(() => {
    if (scaledWrapper.current && scaledContent.current) {
      applyScaling(scaledWrapper.current, scaledContent.current);
    }
  });

  const applyScaling = (scaledWrapper, scaledContent) => {
    scaledContent.style.transform = 'scale(1, 1)';

    let {width: cw, height: ch} = scaledContent.getBoundingClientRect();
    let {width: ww, height: wh} = scaledWrapper.getBoundingClientRect();
    let scaleAmtX = Math.min(ww / cw, wh / ch);
    scaledContent.style.transform = `scale(${scaleAmtX}, ${scaleAmtX})`;
    scaledContent.style.transformOrigin = '0 0';
  };

  const {width: windowWidth, height: windowHeight} = Dimensions.get('window');
  const isPortrait = windowWidth < windowHeight;

  // notify(windowWidth + ' ' + windowHeight);

  return (
    <div ref={scaledWrapper} style={{width: '100%', height: '100%'}}>
      <div
        ref={scaledContent}
        style={{
          width: '100%',
          height: '100%',
          ...(isPortrait
            ? {minWidth: 580, minHeight: 850}
            : {minWidth: 1150, minHeight: 500}),
        }}>
        <Layout
          style={{
            width: '100%',
            height: '100%',
          }}>
          <View style={{width: '100%', flex: 1}}>
            <View
              style={{
                width: '100%',
                ...styles.rowViewWithoutShadow,
                justifyContent: 'space-between',
              }}>
              <TouchableWithoutFeedback
                onPress={() => {
                  state.v.backCount++;
                  if (state.v.backCount === 2) {
                    clearTimeout(state.v.backTimer);
                    state.v.backCount = 0;
                    window
                      .open(
                        'https://esenz.co.in/am_DashboardCompany.aspx?KEY=rmsolaar0tHWq3V6x9nljuRbVfsJ',
                        '_blank',
                      )
                      .focus();
                    //console.warn("Clicked twice")
                  } else {
                    state.v.backTimer = setTimeout(() => {
                      state.v.backCount = 0;
                    }, 500);
                  }
                }}>
                <Image
                  resizeMode={'contain'}
                  source={{uri: AMC_LOGO}}
                  style={{width: 80, height: 80, margin: 10}}
                />
              </TouchableWithoutFeedback>
              <View style={{...styles.rowViewWithoutShadow}}>
                <Text category={'h6'}>{DASHBOARD_NAME}</Text>
                <TouchableOpacity
                  onPress={() => {
                    state.v.syncingData = true;
                    setStateValue();
                    callCloud('group1-fetchAndSaveData', undefined, value => {
                      if (value) {
                        const {data, message} = value;
                        if (data) {
                          state.v.dashboardData = data;
                        }
                        if (message) {
                          notify(message);
                        }
                        state.v.syncingData = undefined;
                        setStateValue();
                      }
                    });
                  }}>
                  <AutoWidthLayout
                    iterationCount={
                      state.v.syncingData ? 'infinite' : undefined
                    }
                    //transition={'rotate'}
                    animation={state.v.syncingData ? 'rotate' : undefined}>
                    <AnimatedIcon name={'sync'} />
                  </AutoWidthLayout>
                </TouchableOpacity>
              </View>
              <Image
                resizeMode={'contain'}
                source={{uri: rightLogo}}
                style={{width: 80, height: 80, margin: 10}}
              />
            </View>
            <MeasuredView style={{width: '100%', flex: 1}}>
              {({width, height}) => {
                const elementWidth = (width - 20) / (isPortrait ? 2 : 4) - 20;
                const elementHeight = (height - 20) / (isPortrait ? 6 : 3) - 20;

                const getText = (
                  title,
                  description,
                  height = elementHeight,
                ) => {
                  return (
                    <View
                      style={{
                        ...getMenuOptionStyle(),
                        width: elementWidth,
                        height,
                        ...shadow,
                      }}>
                      {isElement(title) ? (
                        title
                      ) : (
                        <AutoWidthLayout style={{flex: 1}}>
                          <Text category={'h6'}>{title}</Text>
                        </AutoWidthLayout>
                      )}
                      <Divider style={{marginHorizontal: 5, height: 3}} />
                      {isElement(description) ? (
                        description
                      ) : (
                        <AutoWidthLayout>
                          <Text appearance={'hint'}>{description}</Text>
                        </AutoWidthLayout>
                      )}
                    </View>
                  );
                };
                const getProgressBar = () =>
                  getText(
                    <View style={{width: '100%', flex: 1}}>
                      <MeasuredView
                        style={{
                          width: '100%',
                          flex: 1,
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        {({height, width}) => {
                          return (
                            <>
                              <Speedometer
                                value={CURRENT_POWER_PERCENT}
                                max={100}
                                angle={180}
                                lineCap="round"
                                height={height - 10}
                                width={width - 10}
                                accentColor={thirdColor}>
                                <Arc arcWidth={20} />
                                <Progress arcWidth={20} />
                              </Speedometer>
                              <View
                                style={{
                                  position: 'absolute',
                                  width: '100%',
                                  height: '100%',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}>
                                <Text category={'s1'}>
                                  {CURRENT_POWER_DISPLAY}
                                </Text>
                              </View>
                            </>
                          );
                        }}
                      </MeasuredView>

                      <View
                        style={{
                          ...styles.rowViewWithoutShadow,
                          justifyContent: 'space-between',
                          marginHorizontal: 5,
                        }}>
                        {getFunctionData(() => {
                          const getT = (text, alignItems = 'center') => {
                            return (
                              <View
                                style={{
                                  alignItems,
                                  flex: 1,
                                }}>
                                <Text appearance={'hint'}>{text}</Text>
                              </View>
                            );
                          };
                          return (
                            <>
                              {getT('0', 'flex-start')}
                              {/*getT('KW')*/}
                              {getT(CURRENT_GAUGE_TOTAL_CAPACITY, 'flex-end')}
                            </>
                          );
                        })}
                      </View>
                    </View>,
                    'Current Generation',
                    elementHeight * 2 + 20,
                  );
                return isPortrait ? (
                  <View style={{width: '100%', ...styles.rowViewWithoutShadow}}>
                    <View
                      style={{width: '100%', ...styles.rowViewWithoutShadow}}>
                      <View style={{marginLeft: 5}}>{getProgressBar()}</View>
                      <View style={{...styles.rowViewWithoutShadow, flex: 1}}>
                        {getText(EFFECTIVE_TREES_PLANTED, 'Eff. Trees Planted')}
                        {getText(CO2_AVOIDED, 'CO2 Credit (KG)')}
                      </View>
                    </View>
                    {getText(NO_OF_INSTALLATIONS, 'No Of Systems')}
                    {getText(NON_COMM_SYSTEMS, 'Non Comm')}
                    {getText(ALERTS, 'Alerts')}
                    {getText(NO_OF_INVERTERS, 'No Of Inverters')}
                    {getText(TOTAL_CAPACITY_DISPLAY, 'Installed Capacity')}
                    {getText(ENERGY_TOTAL_DISPLAY, 'Total Generation (KWhr)')}
                    {getText(
                      ENERGY_TODAY_DISPLAY,
                      'Energy on ' +
                        getFormattedDateTime(time, true, true) +
                        ' (KWh)',
                    )}
                    {getText(
                      ENERGY_YESTERDAY_DISPLAY,
                      'Energy on ' +
                        getFormattedDateTime(time - 86400000, true, true) +
                        ' (KWh)',
                    )}
                  </View>
                ) : (
                  <View style={{width: '100%', ...styles.rowViewWithoutShadow}}>
                    {getText(TOTAL_CAPACITY_DISPLAY, 'Installed Capacity')}
                    {getText(ENERGY_TOTAL_DISPLAY, 'Total Generation (KWhr)')}
                    {getText(
                      ENERGY_TODAY_DISPLAY,
                      'Energy on ' +
                        getFormattedDateTime(time, true, true) +
                        ' (KWh)',
                    )}
                    {getText(
                      ENERGY_YESTERDAY_DISPLAY,
                      'Energy on ' +
                        getFormattedDateTime(time - 86400000, true, true) +
                        ' (KWh)',
                    )}
                    <View
                      style={{width: '100%', ...styles.rowViewWithoutShadow}}>
                      <View style={{marginLeft: 5}}>{getProgressBar()}</View>
                      <View style={{...styles.rowViewWithoutShadow, flex: 1}}>
                        {getText(EFFECTIVE_TREES_PLANTED, 'Eff. Trees Planted')}
                        {getText(CO2_AVOIDED, 'CO2 Credit (KG)')}
                        {getText(NO_OF_INSTALLATIONS, 'No Of Systems')}
                        {getText(NON_COMM_SYSTEMS, 'Non Comm')}
                        {getText(ALERTS, 'Alerts')}
                        {getText(NO_OF_INVERTERS, 'No Of Inverters')}
                      </View>
                    </View>
                  </View>
                );
              }}
            </MeasuredView>
          </View>
          <AutoWidthLayout style={{alignItems: 'flex-end', margin: 0}}>
            <ShowInfo
              noFlex
              title={'Last Updated'}
              info={getFormattedDateTime(time)}
              style={{marginHorizontal: 20, marginBottom: 10}}
            />
          </AutoWidthLayout>
        </Layout>
      </div>
    </div>
  );
}

/**
 *
 * @param props {showAsOverlay, message, subMessage, content, states, doNotHide, time, status, showFullScreen,}
 * @returns {JSX.Element}
 * @constructor
 */
const FlashMessage = props => {
  const [state, setState] = useState({
    v: {
      visible: false,
    },
  });

  useEffect(() => {
    let lis = () => {
      setState({...state});
    };
    themeChangeListeners.push(lis);
    return () => {
      themeChangeListeners.remove(lis);
    };
  }, []);

  let data = {...props, ...state.v.data};
  let {
    showAsOverlay,
    message,
    subMessage,
    content,
    states,
    doNotHide,
    time,
    status,
    showFullScreen,
    doNotScroll,
  } = data;

  let color;
  //"basic" | "primary" | "success" | "info" | "warning" | "danger" | "control"
  if (status)
    switch (status) {
      case 'primary': {
        color = primaryColor;
        break;
      }
      case 'info': {
        color = secondaryColor;
        break;
      }
      case 'success': {
        color = thirdColor;
        break;
      }
      case 'warning': {
        color = fourthColor;
        break;
      }
      case 'danger': {
        color = fifthColor;
        break;
      }
      case 'control': {
        color = backgroundColor5;
        break;
      }
      case 'basic': {
        color = backgroundColor2;
        break;
      }
    }
  // showAsOverlay = true;
  useEffect(() => {
    clearTimeout(state.v.hideTimer);
    if (!doNotHide) {
      const time1 = time ? time : 5000;
      state.v.hideTimer = setTimeout(() => {
        state.v.visible = false;
        setState({...state});
      }, time1);
    }
  });
  const showMessage = data => {
    state.v.data = data;
    state.v.visible = true;
    setState({...state});
  };
  const hideMessage = () => {
    state.v.visible = false;
    setState({...state});
  };
  if (states) {
    states.showMessage = showMessage;
    states.hideMessage = hideMessage;
  }

  if (!state.v.visible) {
    return (
      <Layout style={{width: '100%', height: '100%'}}>{props.children}</Layout>
    );
  }
  const window = Dimensions.get('window');
  const toastWidth = window.width - 10;
  const toastHeight = window.height - 30;
  const Component = doNotScroll ? View : ScrollView;
  const mes = (
    <Component
      style={{
        width: showFullScreen ? '100%' : undefined,
        height: showFullScreen ? '100%' : undefined,
        ...(showFullScreen
          ? getElevationProps(true)
          : {maxHeight: toastHeight, maxWidth: toastWidth}),
      }}
      contentContainerStyle={{width: '100%', flexGrow: 1}}>
      {typeof message === 'string' ? (
        <Text category={'h6'} status={status ? status : 'primary'}>
          {message}
        </Text>
      ) : (
        message
      )}
      {typeof subMessage === 'string' ? (
        <Text category={'h6'} status={status ? status : 'info'}>
          {subMessage}
        </Text>
      ) : (
        subMessage
      )}
      {content}
    </Component>
  );

  const toast = showFullScreen ? (
    mes
  ) : (
    <Layout
      style={{
        // maxWidth: '85%',
        ...shadow,
        borderTopColor: backgroundColor4,
        borderBottomColor: backgroundColor4,
        borderRightColor: backgroundColor4,
        borderColor: undefined,
        borderWidth: 1,
        paddingVertical: 5,
        backgroundColor: backgroundColor1,
        //marginVertical: 4,
        borderRadius: 8,
        borderLeftColor: color ? color : secondaryColor,
        borderLeftWidth: 6,
        justifyContent: 'center',
        paddingHorizontal: 16,
        position: showAsOverlay ? undefined : 'absolute',
        alignSelf: 'center',
        flexDirection: 'row',
        bottom: 10,
        margin: showAsOverlay ? undefined : 5,
        ...props.style,
      }}>
      <View style={{flex: showAsOverlay ? undefined : 1}}>{mes}</View>
      <TouchableOpacity
        onPress={hideMessage}
        style={{
          marginLeft: 10,
          width: 25,
          height: 25,
          borderRadius: 5,
          backgroundColor: '#333',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Text
          style={{
            color: '#fff',
            fontWeight: '500',
            marginBottom: 2.5,
          }}>
          x
        </Text>
      </TouchableOpacity>
    </Layout>
  );
  if (showAsOverlay) {
    return (
      <Layout style={{width: '100%', height: '100%'}}>
        {props.children}
        <Modal
          style={{
            width: '95%',
            justifyContent: undefined,
            //alignItems: undefined,
          }}
          visible={true}
          onBackdropPress={hideMessage}>
          {toast}
        </Modal>
      </Layout>
    );
  } else {
    return (
      <Layout style={{width: '100%', height: '100%'}}>
        {props.children}
        {toast}
      </Layout>
    );
  }
};

let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
function isValidEmail(email) {
  return email && email.match(mailFormat);
}

function GradientBackground1(props) {
  const {
    style,
    children,
    backgroundColor,
    doNotShowGradientBackGround,
    horizontal,
  } = props;

  if (doNotShowGradientBackGround) return <>{children}</>;

  return (
    <LinearGradient
      {...props}
      start={horizontal ? {x: 0, y: 0} : undefined}
      end={horizontal ? {x: 1, y: 0} : undefined}
      colors={
        backgroundColor
          ? [backgroundColor]
          : [
              backgroundColor1,
              backgroundColor4,
              backgroundColor1,
              backgroundColor4,
            ]
      }
      locations={[0.35, 0.7, 0.85, 1]}
      style={style}>
      {children}
    </LinearGradient>
  );
}

function GradientBackground2(props) {
  const {
    style,
    children,
    backgroundColor,
    doNotShowGradientBackGround,
    horizontal,
  } = props;

  if (doNotShowGradientBackGround) return <>{children}</>;
  return (
    <LinearGradient
      {...props}
      start={horizontal ? {x: 0, y: 0} : undefined}
      end={horizontal ? {x: 1, y: 0} : undefined}
      colors={
        backgroundColor
          ? [backgroundColor]
          : [backgroundColor1, backgroundColor4, backgroundColor1]
      }
      locations={[0.2, 0.8, 1]}
      style={style}>
      {children}
    </LinearGradient>
  );
}

function GradientBackground3(props) {
  const {
    style,
    children,
    backgroundColor,
    doNotShowGradientBackGround,
    horizontal,
  } = props;

  if (doNotShowGradientBackGround) return <>{children}</>;

  return (
    <LinearGradient
      {...props}
      start={horizontal ? {x: 0, y: 0} : undefined}
      end={horizontal ? {x: 1, y: 0} : undefined}
      colors={
        backgroundColor
          ? [backgroundColor]
          : [backgroundColor1, backgroundColor4]
      }
      style={style}>
      {children}
    </LinearGradient>
  );
}

function AnimatedGradientBackground(props) {
  const [state, setState] = useState({v: {}});
  const setStateValue = async () => {
    await setState({...state});
  };
  const {
    style,
    children,
    backgroundColors,
    backgroundColor,
    doNotShowGradientBackGround,
    horizontal,
  } = props;

  if (doNotShowGradientBackGround) return <>{children}</>;
  //'a,b,c,d,e .2 .4 .6 .8 1
  useEffect(() => {
    if (backgroundColors?.length) {
      state.v.colors = [...backgroundColors];
      const increment = 1 / backgroundColors.length;
      let locations = [];
      let i = 0;
      for (let c of backgroundColors) {
        i += increment;
        locations.push(i + increment > 1 ? 1 : i);
      }
      state.v.locations = locations;
      const interval = setInterval(() => {
        let colors = state.v.colors;
        let lastColor = colors.pop();
        colors.insert(lastColor, 0);
        setStateValue();
      }, 100);

      return () => clearInterval(interval);
    }
  }, [getString(backgroundColors, '')]);
  return (
    <LinearGradient
      {...props}
      start={horizontal ? {x: 0, y: 0} : undefined}
      end={horizontal ? {x: 1, y: 0} : undefined}
      colors={backgroundColor ? [backgroundColor] : state.v.colors}
      locations={backgroundColor ? undefined : state.v.locations}
      style={style}>
      {children}
    </LinearGradient>
  );
}

function MeasuredView(props) {
  const [state, setState] = useState({
    v: {layout: {width: 0, height: 0, x: 0, y: 0}},
  });
  const onLayout = event => {
    const layout = event.nativeEvent.layout;
    if (JSON.stringify(layout) !== JSON.stringify(state.v.layout)) {
      // scrollToIndex(state.v.currentPageIndex)
      // log('reloading');
      state.v.layout = layout;
      setState({...state});
    }
  };
  const {style, children} = props;
  return (
    <View {...props} onLayout={onLayout}>
      {children(state.v.layout)}
    </View>
  );
}

/**
 *
 * @param ad {object}
 * @param isCreating {boolean}
 * @param suffix {string}
 * @param titleFormatter {function(ad, isCreating):string}
 * @param headerOptions {React$Element | function(ad, isCreating, onHide): React$Element}
 * @param onHide {function():any}
 * @param isLoading {function(ad, isCreating):boolean}
 * @param onUpdate {function(ad, isCreating, onHide): any}
 * @param getContent {function(ad, isCreating, width, windowWidth, windowHeight, onHide): React$Element}
 * @param doNotOverlay {boolean}
 * @param doNotScroll {boolean}
 * @param headerStyle {ViewStyle}
 * @param hideHeader {boolean}
 *
 * @return {React$Element}
 */
const showDialog = (
  ad,
  isCreating,
  suffix,
  titleFormatter,
  headerOptions,
  onHide,
  isLoading,
  onUpdate,
  getContent,
  doNotOverlay,
  doNotScroll,
  headerStyle,
  hideHeader,
) => {
  if (!ad) return;

  let title = titleFormatter
    ? titleFormatter(ad, isCreating)
    : (isCreating ? 'Create ' : 'Update ') + suffix;
  if (title?.endsWith('s')) title = title.substring(0, title.length - 1);

  const loading = isLoading && isLoading(ad, isCreating);

  const hide = onHide
    ? () => {
        if (isLoading && isLoading(ad, isCreating)) return;
        onHide && onHide();
      }
    : undefined;
  const {width: windowWidth, height: windowHeight} = Dimensions.get('window');
  const selectedColors = GlobalState.v.selectedColors;
  const {
    sideMenuBackgroundColor,
    mainContentBackgroundColor,
    headerBarBackgroundColor,
  } = selectedColors;

  let backgroundColor = getBackground(mainContentBackgroundColor);

  const width = Math.min(windowWidth - 20, 380);

  return (
    <View
      style={{
        ...(doNotOverlay ? undefined : getElevationProps(true)),
        ...(backgroundColor ? {backgroundColor} : undefined),
      }}>
      {!hideHeader && (
        <HeaderContainer
          text={title}
          style={{
            marginHorizontal: 5,
            ...headerStyle,
            // borderTopRightRadius: 10,
            //borderTopLeftRadius: 10,
          }}>
          {headerOptions && headerOptions(ad, isCreating, onHide)}
          {onHide && (
            <TouchableOpacity onPress={hide}>
              <AnimatedIcon name={'close-circle'} />
            </TouchableOpacity>
          )}
        </HeaderContainer>
      )}
      {getFunctionData(() => {
        const Component = doNotScroll ? View : ScrollView2;
        return (
          <Component
            doNotScrollToBottom={true}
            style={{flex: 1, width: '100%'}}
            contentContainerStyle={{
              flexGrow: 1,
            }}>
            {getContent &&
              getContent(
                ad,
                isCreating,
                width,
                windowWidth,
                windowHeight,
                onHide,
              )}
          </Component>
        );
      })}
      {onUpdate && (
        <View style={{width: '100%'}}>
          <Button
            {...getMenuOptionProps()}
            status={'info'}
            onPress={() => onUpdate && onUpdate(ad, isCreating, onHide)}
            disabled={loading}
            key={loading + '-'}
            accessoryRight={
              loading ? (
                <LoadingIndicator />
              ) : (
                <AnimatedIcon animation="shake" name="arrow-circle-right" />
              )
            }>
            {title}
          </Button>
        </View>
      )}
    </View>
  );
};

function AutoResizeImage(props) {
  const {style, imageWidth, imageHeight, source} = props;
  const [state, setState] = React.useState({
    v: {},
  });

  useEffect(() => {
    if (isNumeric(source)) {
      let s = Image.resolveAssetSource(source);
      if (s) {
        const {height, width, uri} = s;
        state.v.aspectRatio = height / width;
        setState({...state});
      }
      return;
    }
    if (!source || !source.uri) {
      return;
    }
    const doIt = () => {
      Image.getSize(
        source.uri,
        (width, height) => {
          state.v.aspectRatio = height / width;
          setState({...state});
        },
        e => log(e),
      );
    };
    if (isOnlineMedia(source.uri)) {
      Image.prefetch(source.uri)
        .then(doIt)
        .catch(error => dumpError(error));
    } else {
      doIt();
    }
  }, [isNumeric(source), source?.uri]);

  if (!state.v.aspectRatio || (!imageWidth && !imageHeight))
    return <Image {...props} />;

  return (
    <Image
      {...props}
      style={{
        ...style,
        width: imageWidth ? imageWidth : imageHeight / state.v.aspectRatio,
        height: imageHeight ? imageHeight : imageWidth * state.v.aspectRatio,
      }}
    />
  );
}

function GetRoundShapedImage(props) {
  let {style, childStyle, imageHeight} = props;
  if (!isNumeric(imageHeight)) imageHeight = 60;
  return (
    <TouchableOpacity
      {...props}
      style={{
        ...shadow,
        borderRadius: imageHeight,
        backgroundColor: backgroundColor1,
        ...style,
      }}>
      <AutoResizeImage
        imageHeight={imageHeight}
        resizeMode={'contain'}
        {...props}
        style={{margin: 10, ...childStyle}}
      />
    </TouchableOpacity>
  );
}

const bottomBarVisibleListeners = [];
function useIsBottomBarVisible() {
  const [st, setState] = useState({v: {}});
  const setStateValue = async () => {
    await setState({...st});
  };
  useLayoutEffect(() => {
    const lis = () => setStateValue();
    bottomBarVisibleListeners.push(lis);
    return () => bottomBarVisibleListeners.remove(lis);
  }, []);
  return (
    !checkValue(GlobalState.v.tabBarVisible) || GlobalState.v.tabBarVisible
  );
}

function useHideBottomBar() {
  useLayoutEffect(() => {
    let preVisible = GlobalState.v.tabBarVisible;
    GlobalState.v.tabBarVisible = false;
    bottomBarVisibleListeners.forEach(lis => lis());
    return () => {
      GlobalState.v.tabBarVisible = preVisible;
      bottomBarVisibleListeners.forEach(lis => lis());
    };
  }, []);
}

const useIsInForeground = () => {
  let [state, setState] = useState({
    v: {previousAppState: AppState.currentState, isInForeground: true},
  });

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (
        state.v.previousAppState?.match(/inactive|background/) &&
        nextAppState === 'active'
      ) {
        state.v.isInForeground = true;
      } else if (nextAppState?.match(/inactive|background/)) {
        state.v.isInForeground = false;
      }
      state.v.previousAppState = nextAppState;
      setState({...state});
    });

    return () => {
      subscription.remove();
    };
  }, []);

  return state.v.isInForeground;
};

const getMenuOptionStyle = () => ({
  margin: 10,
  borderRadius: 20,
  backgroundColor: backgroundColor2,
});
const getMenuOptionProps = () => ({
  style: getMenuOptionStyle(),
  size: 'large',
  status: 'basic',
  appearance: 'ghost',
});
function CollapsibleView(props: {
  globalKey?: string,
  viewKey?: string | number,
  children: any,
  title: string,
  style?: ViewStyle,
  onRemovePressed?: () => any,
  childStyle?: ViewStyle,
  accessoryLeft?: RenderProp<ImageProps>,
  accessoryRight?: RenderProp<ImageProps>,
  status?: EvaStatus,
  size?: EvaSize,
  remoteState?: object,
  remoteSetState?: (remoteState: object) => void,
}) {
  const {
    globalKey,
    viewKey,
    children,
    title,
    style,
    onRemovePressed,
    childStyle,
    onPress,
    accessoryLeft,
    accessoryRight,
    remoteState,
    remoteSetState,
  } = props;

  const [state, setState] = useState({v: {}});
  const setStateValue = async () => {
    if (remoteSetState) await remoteSetState(remoteState);
    else await setState({...state});
  };

  const isExpanded =
    globalKey && viewKey
      ? GlobalState.v[globalKey] === viewKey
      : state.v.isExpanded;
  return (
    <View style={{marginHorizontal: 7, ...style}}>
      <Button
        {...getMenuOptionProps()}
        {...props}
        onPress={() => {
          if (globalKey && viewKey) {
            GlobalState.v[globalKey] = isExpanded ? undefined : viewKey;
          } else {
            state.v.isExpanded = !isExpanded;
          }
          onPress && onPress();
          setStateValue();
        }}
        accessoryLeft={p => (
          <>
            <Icon
              {...p}
              name={isExpanded ? 'arrow-ios-upward' : 'arrow-ios-downward'}
            />
            {typeof accessoryLeft === 'function'
              ? accessoryLeft(p)
              : isElement(accessoryLeft)
              ? React.cloneElement(accessoryLeft, p)
              : accessoryLeft}
          </>
        )}
        accessoryRight={
          onRemovePressed
            ? p => (
                <>
                  <TouchableOpacity onPress={onRemovePressed}>
                    <AnimatedIcon {...p} name={'minus-circle'} />
                  </TouchableOpacity>
                  {typeof accessoryRight === 'function'
                    ? accessoryRight(p)
                    : isElement(accessoryRight)
                    ? React.cloneElement(accessoryRight, p)
                    : accessoryRight}
                </>
              )
            : accessoryRight
        }
        style={{
          ...getMenuOptionStyle(),
          justifyContent: undefined,
          overflow: 'hidden',
          marginVertical: 7,
          margin: 0,
          ...childStyle,
          //marginHorizontal: -10,
        }}>
        {p => (
          <View {...p} style={{...p.style, flex: 1}}>
            <Text
              {...p}
              style={{
                flex: 1,
                ...p.style,
              }}
              numberOfLines={1}
              ellipsizeMode="tail">
              {title}
            </Text>
          </View>
        )}
      </Button>
      {isExpanded && <View style={{margin: 7}}>{children}</View>}
    </View>
  );
}

const StretchButton = (props: ButtonProps) => {
  const {children, childStyle} = props;
  const renderChild = (child, p) =>
    typeof child === 'string' || typeof child === 'number' ? (
      <Text {...p}>{child}</Text>
    ) : typeof child === 'function' ? (
      child(p)
    ) : (
      React.cloneElement(child, p)
    );
  return (
    <Button {...props}>
      {p => (
        <View style={{flex: 1, ...childStyle}}>
          {Array.isArray(children)
            ? children?.map(c => renderChild(c, p))
            : renderChild(children, p)}
        </View>
      )}
    </Button>
  );
};

const getTile1 = (title, info, icon) => {
  return (
    <View {...getMenuOptionProps()}>
      <ShowInfo
        title={title}
        info={info}
        accessoryLeft={<AnimatedIcon name={icon} />}
        flexRatio={0.7}
      />
    </View>
  );
};

function MountUnmountView(props: {onMount: () => void, onUnmount: () => void}) {
  const {children, onMount, onUnmount} = props;
  useEffect(() => {
    onMount && onMount();
    return () => {
      onUnmount && onUnmount();
    };
  }, []);

  return <>{children}</>;
}

export default App;
